export default "__VITE_ASSET__DpClqOVa__"